import { Check, Notice, Text } from 'telia-front-react';
import { observer } from 'mobx-react';
import React from 'react';
import useStores from '../stores/UseStores';

interface RememberMeProps {
  tabItemId: string;
}

const RememberMe = observer((props: RememberMeProps): JSX.Element | null => {
  const { tabItemId } = props;
  const {
    rememberMeStore: { rememberMe, hideRememberMe, setRememberMe },
    translateStore: { translate },
  } = useStores();
  if (hideRememberMe) {
    return null;
  }

  const uniqueId = `remember_me_${tabItemId}`;

  return (
    <Text className={'text-left'}>
      <>
        <Check
          input={{ name: 'remember_me' }}
          value={`${rememberMe}`}
          id={uniqueId}
          onChange={(selected: boolean) => {
            setRememberMe(selected);
          }}
          checked={rememberMe}
          labelText={translate('rememberme')}
        />
      </>
      <span aria-live="polite">
        {rememberMe && (
          <Notice size="small" className="text-small">
            <p>{translate('rememberme.notice')}</p>
          </Notice>
        )}
      </span>
    </Text>
  );
});

export default RememberMe;
